import type { Template } from "@/types";

export const LA_05_H0_V5: Template[] = [
    {
        id: "la-05-h0v5-01",
        name: "LA 01 - H0V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h0_v5_01.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 93, y: 96, width: 227, height: 348, rotation: 0, imageRotation: 0 },
            { id: "2", x: 328, y: 96, width: 227, height: 348, rotation: 0, imageRotation: 0 },
            { id: "3", x: 563, y: 96, width: 227, height: 348, rotation: 0, imageRotation: 0 },
            { id: "4", x: 798, y: 96, width: 227, height: 348, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1033, y: 96, width: 227, height: 348, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h0v5-02",
        name: "LA 02 - H0V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h0_v5_02.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 68, width: 264, height: 404, rotation: 0, imageRotation: 0 },
            { id: "2", x: 272, y: 68, width: 264, height: 404, rotation: 0, imageRotation: 0 },
            { id: "3", x: 544, y: 68, width: 264, height: 404, rotation: 0, imageRotation: 0 },
            { id: "4", x: 816, y: 68, width: 264, height: 404, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1088, y: 68, width: 264, height: 404, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h0v5-03",
        name: "LA 03 - H0V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h0_v5_03.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 142, y: 194, width: 192, height: 296, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 194, width: 192, height: 296, rotation: 0, imageRotation: 0 },
            { id: "3", x: 719, y: 194, width: 192, height: 296, rotation: 0, imageRotation: 0 },
            { id: "4", x: 919, y: 194, width: 191, height: 296, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1118, y: 194, width: 191, height: 296, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h0v5-04",
        name: "LA 04 - H0V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h0_v5_04.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 147, y: 0, width: 383, height: 541, rotation: 0, imageRotation: 0 },
            { id: "2", x: 800, y: 45, width: 300, height: 450, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1107, y: 45, width: 118, height: 145, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1107, y: 198, width: 118, height: 145, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1107, y: 351, width: 118, height: 144, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h0v5-05",
        name: "LA 05 - H0V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h0_v5_05.png",
        size: [1352, 541],
        style: {},
        slots: [        
            { id: "1", x: 189, y: 52, width: 146, height: 215, rotation: 0, imageRotation: 0 },
            { id: "2", x: 189, y: 275, width: 146, height: 215, rotation: 0, imageRotation: 0 },
            { id: "3", x: 343, y: 52, width: 145, height: 215, rotation: 0, imageRotation: 0 },
            { id: "4", x: 343, y: 275, width: 145, height: 215, rotation: 0, imageRotation: 0 },
            { id: "5", x: 820, y: 0, width: 388, height: 541, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h0v5-06",
        name: "LA 06 - H0V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h0_v5_06.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 123, y: 54, width: 281, height: 436, rotation: 0, imageRotation: 0 },
            { id: "2", x: 412, y: 54, width: 144, height: 214, rotation: 0, imageRotation: 0 },
            { id: "3", x: 412, y: 276, width: 144, height: 214, rotation: 0, imageRotation: 0 },
            { id: "4", x: 777, y: 96, width: 234, height: 348, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1019, y: 96, width: 233, height: 348, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h0v5-07",
        name: "LA 07 - H0V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h0_v5_07.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 130, y: 45, width: 294, height: 450, rotation: 0, imageRotation: 0 },        
            { id: "2", x: 431, y: 45, width: 115, height: 145, rotation: 0, imageRotation: 0 },
            { id: "3", x: 431, y: 198, width: 115, height: 145, rotation: 0, imageRotation: 0 },
            { id: "4", x: 431, y: 351, width: 115, height: 144, rotation: 0, imageRotation: 0 },
            { id: "5", x: 853, y: 45, width: 321, height: 450, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h0v5-08",
        name: "LA 08 - H0V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h0_v5_08.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 188, y: 50, width: 300, height: 441, rotation: 0, imageRotation: 0 },
            { id: "2", x: 860, y: 50, width: 150, height: 217, rotation: 0, imageRotation: 0 },
            { id: "3", x: 860, y: 275, width: 150, height: 217, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1018, y: 50, width: 150, height: 217, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1018, y: 275, width: 150, height: 217, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h0v5-09",
        name: "LA 09 - H0V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h0_v5_09.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 106, y: 48, width: 322, height: 444, rotation: 0, imageRotation: 0 },
            { id: "2", x: 435, y: 48, width: 157, height: 218, rotation: 0, imageRotation: 0 },
            { id: "3", x: 435, y: 274, width: 157, height: 218, rotation: 0, imageRotation: 0 },
            { id: "4", x: 599, y: 48, width: 321, height: 444, rotation: 0, imageRotation: 0 },
            { id: "5", x: 927, y: 48, width: 321, height: 444, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h0v5-10",
        name: "LA 10 - H0V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h0_v5_10.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 106, y: 48, width: 322, height: 445, rotation: 0, imageRotation: 0 },
            { id: "2", x: 435, y: 48, width: 321, height: 445, rotation: 0, imageRotation: 0 },
            { id: "3", x: 763, y: 48, width: 321, height: 445, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1091, y: 48, width: 157, height: 218, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1091, y: 274, width: 157, height: 219, rotation: 0, imageRotation: 0 }
        ],
    }
];